import { render } from "./UserTransfersTable.vue?vue&type=template&id=038a3a60&scoped=true"
import script from "./UserTransfersTable.vue?vue&type=script&lang=js"
export * from "./UserTransfersTable.vue?vue&type=script&lang=js"

import "./UserTransfersTable.vue?vue&type=style&index=0&id=038a3a60&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038a3a60"]])

export default __exports__